module.exports = __webpack_public_path__ + "img/whatsapp-original.64955b28.png";